import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PolicyUpdatePolicy } from '@store/flow-data/policy';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { GetPolicyFailure, GetPolicyRequest, GetPolicySuccess } from './actions';
import { GetPolicyService } from './service';

@Injectable()
export class GetPolicyEffects {
  private readonly actions$ = inject(Actions);
  private readonly getPolicyService = inject(GetPolicyService);

  getPolicy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetPolicyRequest),
      switchMap(({ parameters }) =>
        this.getPolicyService.getPolicy(parameters).pipe(
          switchMap(data => [PolicyUpdatePolicy({ data }), GetPolicySuccess({ data })]),
          catchError(error => of(GetPolicyFailure({ error })))
        )
      )
    )
  );

}
